<template>
  
  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="goBack()">
        <i class="reply icon m-r-5"></i> Órgãos
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">

      <div class="ui segment form-segment">
        <h4 class="ui dividing header">Dados do Órgão</h4>
        <div class="ui form">          
          <div class="fields">
            <div class="six wide field">
              <label class="form-label">Nome <span class="red text">*</span></label>
              <input class="uppercase" v-model="organ.name" @blur="organ.name = $toUpperCase($event)">
            </div>
            <div class="ten wide field">
              <label class="form-label">Descrição <span class="red text">*</span></label>
              <input class="uppercase" v-model="organ.description" @blur="organ.description = $toUpperCase($event)">
            </div>
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Texto Padrão</label>
              <text-editor ref="defaultTextEditor" />
            </div>               
          </div>                    
        </div>
      </div>  

      <div class="ui segment form-segment">

        <h4 class="ui dividing header">Alterações</h4>

        <button class="ui mini basic button" @click="$refs.changeModal.create()">
          <i class="plus blue icon"></i> Adicionar
        </button>
        
        <table v-if="hasChanges" class="ui celled selectable tablet stackable table animated fadeIn">
          <thead v-if="$isDesktop">
            <tr>
              <th>Nome</th>
              <th>Descrição</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-if="!change.removed" v-for="(change, index) in organ.changes" @click="onChangeClick(index)">
              <td>
                <strong class="mobile-only">Nome: </strong> {{ change.name }}                  
              </td>
              <td>
                <strong class="mobile-only">Descrição: </strong> {{ $truncateString(change.description, 170) }}  
              </td>                   
              <td style="width: 50px;">
                <button class="ui small icon button" @click="onRemoveChange($event, index)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-20 animated fadeIn">
          <i class="info circle icon"></i> Nenhuma alteração adicionada
        </p>

      </div>

      <div class="m-t-20">
        <button class="ui basic button" @click="goBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating" class="ui basic red button m-l-10" 
          :class="{ loading: checkingRemoval || removing, disabled: saving }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

      <change-modal ref="changeModal" @onCreate="onAddChange" @onUpdate="onUpdateChange" />

      <can-not-remove-modal ref="canNotRemoveModal" />

      <yes-no-modal ref="confirmRemovalModal" danger="true"
        :message="`Confirma exclusão do órgão ${organ.description} ?`"  @onYes="onConfirmRemoval()" />

    </div>  

  </div>

</template> 

<script>

  import { formPage, onlySimavet } from "@/mixins"
  import OrganService from "@/services/organ-service"
  import TextEditor from "@/components/text-editor"
  import ChangeModal from "./change-modal"  

  export default {
    
    name: "OrganForm",

    mixins: [formPage, onlySimavet],

    data() {
      return {
        indexRoute: "/entries/organs",
        creatingTitle: "Novo Órgão",
        updatingTitle: "Alterar Órgão",
        service: new OrganService(),
        organ: { changes: [] },  
        selectedChangeIndex: null,      
      }
    },    

    components: { 
      ChangeModal,
      TextEditor, 
    },

    mounted() {

      if (this.isUpdating)
        this.loadOrgan()      
    },

    computed: {

      hasChanges() {

        let exists = false

        for (let change of this.organ.changes) {
          if (!change.removed) {
            exists = true
            break
          }  
        }

        return exists
      },
    },

    methods: {

      async loadOrgan() {

        this.loading = true

        try {

          this.organ = await this.service.findById(this.$route.params.id)

          if (this.organ.defaultTextContents)
            this.$refs.defaultTextEditor.setContents(this.organ.defaultTextContents)

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onChangeClick(index) {

        this.selectedChangeIndex = index
        
        this.$refs.changeModal.update(this.organ.changes[index])
      },

      onAddChange(change) {
        this.organ.changes.push(change)
      },  

      onUpdateChange(change) {

        let changes = this.organ.changes.slice()

        changes[this.selectedChangeIndex] = change

        this.organ.changes = changes.slice()
      },

      onRemoveChange($event, index) {

        $event.stopPropagation()
        
        let changes = this.organ.changes.slice()

        changes[index].removed = true

        this.organ.changes = changes
      },

      async onConfirm() {

        if (!this.validData())
          return

        this.saving = true

        try {

          this.organ.defaultText = this.$refs.defaultTextEditor.getText()
          this.organ.defaultTextContents = this.$refs.defaultTextEditor.getContents({ toString: true })

          if (this.isCreating) {
            await this.service.create(this.organ)
          } else {
            await this.service.update(this.organ)
          }

          this.$reloadDataTables()

          this.$msg.success(this.isCreating ? "Órgão criado com sucesso" : "Órgão atualizado com sucesso")

          this.goBack()

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.organ.name) {
          message = "Informe o nome do órgão"
        } else if (!this.organ.description) {
          message = "Informe a descrição do órgão"
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.organ)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {

          await this.service.remove(this.organ)

          this.$reloadDataTables()

          this.$msg.success("Órgão excluído com sucesso")

          this.goBack()

        } catch (error) {

          this.removing = false

          this.$errorHandler(error)
        }
      },
    },
  }

</script>